import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import {
  BackgroundService,
  GloveBackgroundDef,
  GloveDefinition,
} from '../../../store/studio/background/background.service';
import {
  CanvasBackground,
  CanvasBackgroundConfig,
} from '../../canvas-background';
import { CustomEllipseBackgroundOptions } from './ellipse-background';
import { Coords } from '../../../../elements/resource/types/shape.type';
import gsap from 'gsap';
/**
 * Renders user-defined ellipses (glows) without animation.
 * - center is normalized in [-2..2] range per axis
 * - radius is normalized in [0..2] range per axis
 */
export class CustomEllipseBackground extends CanvasBackground {
  constructor(
    bgService: BackgroundService,
    private readonly options: CustomEllipseBackgroundOptions,
    config: CanvasBackgroundConfig = {},
  ) {
    super(bgService, config);
    this.init();
  }

  setBackground(def: GloveBackgroundDef) {
    // -- // -- // -- //
  }
  animateBackground(def: GloveBackgroundDef) {
    // return this.gsapAnimate(motions); // -- //
  }
  setByGloveDefinitions(defs: Record<string, GloveDefinition>) {
    Object.entries(defs).map(([key, def]) => {
      this._gloves[key]?.updatePosition(def.center);
    });
  }

  addToCanvas() {
    this.container.removeChildren();
    Object.values(this._gloves).forEach(glove => {
      this.container.addChild(glove.sprite);
    });
  }
  private toPixelsCenter([nx, ny]: Coords): Coords {
    const cx = ((nx + 2) / 4) * _screenX;
    const cy = ((ny + 2) / 4) * _screenY;
    return [cx, cy];
  }

  private toPixelsRadius([rx, ry]: Coords): Coords {
    // Map 1.0 -> quarter of screen dimension (similar to EllipseBackground defaults)
    const px = (rx * _screenX) / 4;
    const py = (ry * _screenY) / 4;
    return [px, py];
  }
  private init() {
    // -- // -- // -- //
    const list = this.options?.ellipse || [];
    Object.entries(list).forEach(([key, e], i) => {
      // const center = this.toPixelsCenter(e.center);
      const radius = this.toPixelsRadius(e.radius);
      this.initGlove(key, {
        color: e.color,
        alpha: e.alpha ?? 1,
        center: e.center,
        radius,
        scale: e.scale,
      });
    });
  }

  gsapAnimate(duration: number, defs: GloveDefinition[]): gsap.core.Timeline {
    const tl = gsap.timeline();
    Object.entries(defs).forEach(([key, def]) => {
      if (!this._gloves[key]) {
        return;
      }
      tl.add(this._gloves[key]?.gsapAnimate(duration, def));
    });

    // -- // -- // -- //
    return tl;
  }

  // Static background (no timeline). Keep hook to conform to base interface.
  setStateByTime(_time: number): void {}
}
